import { render, staticRenderFns } from "./AppFaqs.vue?vue&type=template&id=6739d270&"
import script from "./AppFaqs.vue?vue&type=script&lang=js&"
export * from "./AppFaqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FaqItem: require('/opt/build/repo/components/basics/FaqItem.vue').default})
